<script setup lang="ts">
import { UIButtonLink } from '@groover-dev/groover-ui'
import { storeToRefs } from 'pinia'

import { useSegmentTrack } from '~/composables/Segment/useSegmentTrack'

import { useUserStore } from '~/stores/user'

const { grooviz: GROOVIZ } = storeToRefs(useUserStore())

const segmentTrack = useSegmentTrack()

function handleTrackReferralAccessSegment() {
  segmentTrack('Referral Curator - Page Accessed', {
    accessed_from: 'top navbar',
  })
}

const commonButtonProps = {
  theme: 'dark' as const,
  size: 'small' as const,
  class: 'tw-whitespace-nowrap',
  color: 'neutral' as const,
}
</script>

<template>
  <div>
    <UIButtonLink
      v-bind="commonButtonProps"
      to="/influencer/list/all/"
      data-test-id="curatorTopNavigationAllCurators"
      >{{ $t('layout.navigation12') }}</UIButtonLink
    >
    <UIButtonLink
      v-bind="commonButtonProps"
      to="/influencer/dashboard/"
      data-test-id="curatorTopNavigationDashboard"
      >{{ $t('layout.navigation03') }}</UIButtonLink
    >
    <UIButtonLink
      v-bind="commonButtonProps"
      to="/influencer/widget/"
      data-test-id="curatorTopNavigationReceiveMore"
      @click="handleTrackReferralAccessSegment"
      >{{ $t('components.nav.loggedInCurator.widget') }}</UIButtonLink
    >
    <UIButtonLink
      v-bind="commonButtonProps"
      to="/influencer/cashout/"
      data-test-id="curatorTopNavigationWallet"
    >
      <span class="tw-hidden lg:tw-inline-block">{{
        $t('layout.navigation08', GROOVIZ)
      }}</span>
      <span class="tw-inline-block lg:tw-hidden">{{
        $t('layout.countNoNumber')
      }}</span>
    </UIButtonLink>
  </div>
</template>
